/* global google */

import has from 'lodash/has';
import find from 'lodash/find';
import {fetchWithState, getFetchedJSON} from './fetch';
import {fetchWithNothing} from '~/misc/fetch';

let settingsByCountry = {};

export const getSettings = (country) => {
  if (!settingsByCountry[country]) {
    settingsByCountry[country] = {
      types: ['(regions)'],
      componentRestrictions: {country: country},
    };
  }
  return settingsByCountry[country];
};

const AUTOCOMPLETE_SETTINGS = getSettings('us');


// const geocompleter = new google.maps.places.AutocompleteService();
// const geoplaces = new google.maps.places.PlacesService(window.document.createElement('div'));

// const geodetails = (place) => new Promise((resolve, reject) => {
//   geoplaces.getDetails(place, (result, status) => {
//     if (status === google.maps.places.PlacesServiceStatus.OK) {
//       resolve(result);
//     } else {
//       reject(status);
//     }
//   });
// });
const geodetails = (place) => fetchWithNothing({
  method: 'POST',
  url: '/tl/city/place',
  body: {
    placeId: place.place_id,
  },
}).then(getFetchedJSON).then((res) => res.results[0]);
// const geocomplete = (input, country = 'us') => new Promise((resolve, reject) => {
//   geocompleter.getPlacePredictions({
//     ...getSettings(country),
//     input,
//   }, (results, status) => {
//     const statuses = google.maps.places.PlacesServiceStatus;
//     if (status === statuses.OK || status === statuses.ZERO_RESULTS) {
//       resolve(results || []);
//     } else {
//       reject(status);
//     }
//   });
// });
const geocomplete = (input, country = 'us') => fetchWithNothing({
  method: 'POST',
  url: '/tl/city/city-auto-complete',
  body: {
    city: input,
  },
}).then(getFetchedJSON).then((res) => {
  res.content.forEach(i => {
    i.description = i.title;
  });
  res.input = input;
  return res;
});

const makePlaceObject = (place) => {
  let result = {
    name: place.name,
  };
  if (!has(place, 'address_components')) {
    return result;
  }

  const parts = place.address_components;

  const include = (name) =>
    (find(parts, i => i.types.includes(name)) || false);

  if (parts[0].types[0] === 'administrative_area_level_1') {
    // state
    result = {
      country: parts[1].short_name,
      state: parts[0].short_name,
      name: parts[0].long_name,
      is_state: true,
    };
  } else if (parts[0].types[0] === 'locality') {
    // city
    result = {
      country: include('country').short_name,
      state: include('administrative_area_level_1').short_name,
      city: include('locality').long_name,
      lat: place.geometry.location.lat,
      lng: place.geometry.location.lng,
      is_city: true,
    };
    result.name = `${result.city}, ${result.state}`;
  } else if (has(place, 'geometry.location')) {
    // other: townships, sublocalities (Manhattan), precise street addresses, etc
    result = {
      country: include('country').short_name,
      state: include('administrative_area_level_1').short_name,
      lat: place.geometry.location.lat,
      lng: place.geometry.location.lng,
      name: parts.filter(i => i.types.includes('political')).map(i => i.short_name).join(', '),
      is_other: true,
    };
  }
  return result;
};

export {
  makePlaceObject,
  AUTOCOMPLETE_SETTINGS,
  geodetails,
  geocomplete,
};



// WEBPACK FOOTER //
// ./src/misc/geocoding.js